export const CROSS_FLOW_MODAL_WIDTH = 968;
export const CROSS_FLOW_MODAL_HEIGHT = 620;
